interface QueryResult {
  data?: {
    name?: string;
    fullName?: string;
    workerName?: string;
    template?: { name?: string };
    form?: { data?: { meta?: { title?: string } } };
  };
}

export interface DynamicLabelMapping {
  idKey: string;
  queryResult: {
    data?: unknown;
  };
  labelKeys: string[];
}

export function createDynamicLabels(
  mappings: DynamicLabelMapping[]
): Record<string, string> {
  const dynamicLabels: Record<string, string> = {};

  mappings.forEach(({ idKey, queryResult, labelKeys }) => {
    if (idKey && queryResult.data) {
      for (const labelKey of labelKeys) {
        const keys = labelKey.split(".");
        let value: unknown = queryResult.data as QueryResult;

        for (const key of keys) {
          value = (value as Record<string, unknown>)?.[key];
        }

        if (typeof value === "string" && value.trim().length > 0) {
          dynamicLabels[idKey] = value;
          break; // Use the first non-empty string
        }
      }
    }
  });

  return dynamicLabels;
}
